export const api = {
  querySignCar: '/bms/PlatformScheduling/queryPlatformSignInVehicle.json',
  voidSignCar: '/bms/PlatformScheduling/cancelPlatformSignInVehicle.json',
  queryLibrary: '/bms/PlatformScheduling/queryPlatformScheduling.json',
  operatePlatform: '/bms/PlatformScheduling/platformScheduling.json',
  jobsDetails: '/bms/PlatformScheduling/queryPlatformJobsDetails.json', // 调度详情
  cancelScheduling: '/bms/PlatformScheduling/cancelPlatformScheduling.json', // 撤销调度
  endJobs: '/bms/PlatformScheduling/endJobs.json', // 结束作业
  work: {
    queryhomeworkPic: '/bms/PlatformScheduling/queryhomeworkPic.json',
    exportHomeworkPic: '/bms/PlatformScheduling/exportHomeworkPic.json',
    exportHomework: '/bms/PlatformScheduling/exportHomework.json',
    workDetail: '/bms/PlatformScheduling/queryJobsDetails.json',
  },
  queryAreaTree: '/cms/account/queryAssociationalDeviceTree.json', // 查询区域
  // 新场站调度
  dispatch: {
    queryPlatformList: '/bms/PlatformScheduling/queryPlatformScheduling.json', // 查询冷库月台信息
    queryLineUpList: '/bms/vehicle/appointment/getPlatformVehicleAppointmentDetailsByPlatformId', // 查询月台排队信息
    updateLineUpList: '/bms/vehicle/appointment/updatePlatformWaitVehicleAppointments.json', // 月台排队调整
    querySignedList: '/bms/coldstorage/dispatchVehicleAppointment/queryDispatchVehicleAppointmentList.json', // 查询签到车辆
    cancelAppointment: '/bms/coldstorage/dispatchVehicleAppointment/cancelDispatchVehicleAppointment.json', // 作废
    assignPlatfrom: '/bms/coldstorage/dispatchVehicleAppointment/allocationPlatformVehicleAppointment.json', // 分派月台
    carTimeLine: '/bms/vehicle/appointment/list.json', // 查询车辆作业情况
    dispatchCompleteWork: '/bms/vehicle/appointment/dispatchCompleteWork.json', // 调度完成作业
    carsRelationship: '/bms/vehicle/appointment/invertedCabinetCarsRelationship.json', // 重车空车绑定
    refreshTime: '/bms/vehicle/appointment/dispatchPageRefreshTime.json', // 页面刷新频率
  }
}
